import { c as _c } from "react/compiler-runtime";
import ProductCard from "./ProductCard";
export default function ProductGrid(t0) {
  const $ = _c(9);
  const {
    products: t1,
    labelMap
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const products = t2;
  let t3;
  if ($[2] !== labelMap || $[3] !== products) {
    let t4;
    if ($[5] !== labelMap) {
      t4 = product => <ProductCard key={product.product_id} product={product} labelMap={labelMap} />;
      $[5] = labelMap;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = products.map(t4);
    $[2] = labelMap;
    $[3] = products;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className="mt-4 grid grid-cols-2 gap-2 lg:gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">{t3}</div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}